import domain from './domain'
export default {
  bhuvan_map: "https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms",
  map_layer: "india3",
  // satellite: "https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py",
  // s_layer: "bhuvan_imagery",
  satellite: "https://bhuvan-ras2.nrsc.gov.in/tilecache/tilecache.py",
   s_layer: "bhuvan_img",
  glof_url: `${domain.Geoserver}/nhp_snowcomponent/wms`,
  glof_layer:'nhp_snowcomponent:DEM',
  glofgangaatlas:'https://bhuvan-staging1.nrsc.gov.in/nhp_mail/Glacial_Lake_Atlas_Ganga_Basin_NRSC.pdf',
  glofindusatlas:'https://bhuvan-staging1.nrsc.gov.in/nhp_mail/GL_Atlas_Indus_12Nov2020_Final.pdf',

  glofgangaatlas_live:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/Glacial_Lake_Atlas_Ganga_Basin_NRSC.pdf',
  glofindusatlas_live:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/GL_Atlas_Indus_12Nov2020_Final.pdf',
  glofbrahmaputraatlas_live:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/Brahmaputra_Glacial_Lake_Atlas_nrsc.pdf',
  IHR_GlacialLake_Atlas:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/IHR_GlacialLake_Atlas.pdf',
  // GhepangGhatrisk:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_GhepangGhatGlacialLake_GLOF_Risk_Assessment_Report.pdf',

  // SuruLake:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_SuruGlacialLake_GLOF_Risk_Assessment_Report.pdf'

  GhepangGhat:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_GhepangGhatGlacialLake_GLOF_Risk_Assessment_Report.pdf',

  Suru:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_SuruGlacialLake_GLOF_Risk_Assessment_Report.pdf',

  Mundiksar:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_MundiksarGlacialLake_GLOF_Risk_Assessment_Report.pdf',

  SamudraTapu:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_SamudraTapuGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  Katkar:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_Katkar_GlacialLake_GLOF_Risk_Assessment_Report.pdf',
  MasarTal:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_MasarTalGlacialLake_GLOF_Risk_Assessment_Report.pdf',

  Safed:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_SafedGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  Saraswati:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_SaraswatiGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  VasudharaTal:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_VasudharaTalGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  Shakocho:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_ShakochoGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  GochungTso:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_GochungTsoGlacialLake_GLOF_Risk_Assessment_Report.pdf',

  Gurudongmar:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_GurudongmarGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  KhangchungTso:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_KhangchungTsoGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  SouthLhonak :'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_SouthLhonakGlacialLake_GLOF_Risk_Assessment_Report.pdf',
  Kedartal :'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NRSC_KedartalGlacialLake_GLOF_Risk_Assessment_Report.pdf',


 compendium:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/Compendium.pdf',
 NHPNrsc:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/NHP_NRSC.pdf',
 report_glof:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/Report_GLOF.pdf',
 et_750:'https://bhuvan.nrsc.gov.in/nhpfs/pdf/ET_750m.pdf',
 


};
